import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'bi-child-report',
  templateUrl: './bi-child-report.component.html',
  styleUrls: ['./bi-child-report.component.scss']
})
export class BiChildReportComponent{
  @Input() ChildReports: any;
  @Input() isRight!: boolean;
  @Input() selectedItem!: string;
  @Input() collapsed!: boolean;
  @Input() selectedMenuItem!: string[];
  activeButton: any;
  childExpandedPanels: { [key: string]: number } = {};

  constructor(private router: Router){
  }

 navigateToScreen(path: string): void {
  this.router.navigateByUrl(`${path}`)
}

  

}
